export default "__VITE_ASSET__83c06c0c__"